import { Component, OnDestroy } from '@angular/core';
import { BaseComponent } from '../component-base';
import { AgreementService } from '../../../modules/association/services/agreement.service';
import { WorkflowService } from '../../../modules/workFlow/services/workflow-service';
import { TasksCountService } from '../../../shared/services/tasks-count.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html'
})
export class HeaderComponent extends BaseComponent implements OnDestroy {
  userName: string = "";
  userRole: string = "";
  willExpireAgreementsCount: number = 0;
  tasksCount: number = 0;

  private tasksCountSubscription: Subscription;

  constructor(private agreementService: AgreementService,
    private workflowService: WorkflowService,
    private tasksCountService: TasksCountService) {
    super();
  }
  ngOnInit(): void {
    this.userName = this.getUserName();
    this.userRole = this.getUserDisplayRole();
    this.getAgreementExpirationCount();

    // Subscribe to reactive tasks count updates
    this.tasksCountSubscription = this.tasksCountService.tasksCount$.subscribe(
      count => {
        this.tasksCount = count;
      }
    );

    // Initial load
    this.tasksCountService.refreshTasksCount();
  }

  getAgreementExpirationCount() {
    this.agreementService.getAgreementDashboard().subscribe({
      next: (res) => {
        if (res && res.success) {
          this.willExpireAgreementsCount = res.value.willExpireCount;
        }
      }
    });
  }

  ngOnDestroy(): void {
    // Clean up subscription to prevent memory leaks
    if (this.tasksCountSubscription) {
      this.tasksCountSubscription.unsubscribe();
    }
  }

  logout() {
    this.authService.logout();
  }
}
